import { dateFromString } from '@retail/utils';
import { ConditionBindingMinimal, FreightConditionDTO } from '../../dtos';

interface FreightConditionProps {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  percentAddon?: number;
  fixedAddOn?: number;
  fixedAddOnUnit?: string;
  validFrom: Date;
  validTo?: Date;
}

export class FreightConditionNew {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  percentAddon?: number;
  fixedAddOn?: number;
  fixedAddOnUnit?: string;
  validFrom: Date;
  validTo?: Date;

  constructor({
    conditionId,
    isInherited,
    inheritedBinding,
    isDeletionCondition,
    percentAddon,
    fixedAddOn,
    fixedAddOnUnit,
    validFrom,
    validTo,
  }: FreightConditionProps) {
    this.conditionId = conditionId;
    this.isInherited = isInherited;
    this.inheritedBinding = inheritedBinding;
    this.isDeletionCondition = isDeletionCondition;
    this.percentAddon = percentAddon;
    this.fixedAddOn = fixedAddOn;
    this.fixedAddOnUnit = fixedAddOnUnit;
    this.validFrom = validFrom;
    this.validTo = validTo;
  }

  static fromDto = (dto: FreightConditionDTO): FreightConditionNew =>
    new FreightConditionNew({
      conditionId: dto.conditionId,
      isInherited: dto.isInherited,
      inheritedBinding: dto.inheritedBinding,
      isDeletionCondition: dto.isDeletionCondition,
      percentAddon: dto.percentAddon,
      fixedAddOn: dto.fixedAddOn,
      fixedAddOnUnit: dto.fixedAddOnUnit,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
    });
}
